module.exports = __webpack_public_path__ + "static/img/jz.aa602b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productCenter/jz.png
// module id = y47W
// module chunks = 0